// src/components/reports/RecordsTable.jsx

import React from 'react';
import ImageCell from './ImageCell';
import { REPORT_COLORS } from './theme';
import { PAGE, getCardStyle } from '../ui';

export default function RecordsTable({ pallets }) {
  return (
    <div
      style={{
        ...getCardStyle(),
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
      }}
    >
      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          overscrollBehavior: 'contain',
        }}
      >
        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 920 }}>
          <thead>
            <tr>
              <th style={{ ...PAGE.type.tableHead, color: PAGE.colors.navy }}>Pallet</th>
              <th style={{ ...PAGE.type.tableHead, color: PAGE.colors.navy }}>Image 1</th>
              <th style={{ ...PAGE.type.tableHead, color: PAGE.colors.navy }}>Image 2</th>
              <th style={{ ...PAGE.type.tableHead, color: PAGE.colors.navy }}>Image 3</th>
              <th style={{ ...PAGE.type.tableHead, color: PAGE.colors.navy }}>Image 4</th>
              <th style={{ ...PAGE.type.tableHead, color: PAGE.colors.navy }}>Status</th>
            </tr>
          </thead>

          <tbody>
            {pallets.map((pallet, rowIndex) => {
              const imageCount = pallet.images.filter(Boolean).length;
              const isComplete = imageCount === 4;

              return (
                <tr
                  key={pallet.id}
                  style={{
                    background: rowIndex % 2 === 0 ? REPORT_COLORS.surface : '#f8fafc',
                  }}
                >
                  <td
                    style={{
                      ...PAGE.type.tableCell,
                      fontWeight: 800,
                      color: PAGE.colors.text,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {pallet.name}
                  </td>

                  {pallet.images.map((imageUrl, imageIndex) => (
                    <td key={imageIndex} style={PAGE.type.tableCell}>
                      <ImageCell url={imageUrl} />
                    </td>
                  ))}

                  <td style={PAGE.type.tableCell}>
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '7px 11px',
                        borderRadius: 999,
                        background: isComplete
                          ? REPORT_COLORS.greenSoft
                          : imageCount > 0
                            ? REPORT_COLORS.amberSoft
                            : REPORT_COLORS.redSoft,
                        color: isComplete
                          ? REPORT_COLORS.green
                          : imageCount > 0
                            ? REPORT_COLORS.amber
                            : REPORT_COLORS.red,
                        fontSize: 12,
                        fontWeight: 900,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {imageCount}/4
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
